module.exports = __webpack_public_path__ + "media/application/images/2023/03_still-1450x816-20c54bc7b163a8735632e3f49032be39.png";